import React from 'react'
import { InputPhoneNumber } from './InputPhoneNumber'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'

function RegulaminComponent() {
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '1px',
    textAlign: 'center',
    marginBottom: '150px'
  }

  const infoBoxStyle = {
    width: '332px',
    height: '142px',
    background: 'rgba(0, 163.20, 255, 0.13)',
    borderRadius: '15px',
    border: '2px rgba(0, 163.20, 255, 0.43) solid',
    margin: '0 auto'
  }

  const infoTextStyle = {
    color: 'black',
    fontSize: '13px',
    fontFamily: 'Poppins',
    fontWeight: '400',
    wordWrap: 'break-word'
  }

  const infoHeaderTextStyle = {
    color: 'black',
    fontSize: '15px',
    fontFamily: 'Poppins',
    fontWeight: '700',
    wordWrap: 'break-word'
  }

  return (
    <div style={containerStyle}>
      <div style={infoBoxStyle}>
        <div style={infoHeaderTextStyle}>Informacja</div>
        <div style={infoTextStyle}>
          Jeśli logujesz sie po raz pierwszy zostaniesz poproszony o przeczytanie i akceptację regulaminu serwisu.
        </div>

        <RegulaminButton />
      </div>
    </div>
  )
}

function RegulaminButton() {
  const buttonStyles = {
    marginTop: '10px',
    borderRadius: '10px',
    background: '#00A3FF',
    color: 'white',
    width: '100px',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: '600',
    boxShadow: 'none'
  }

  return (
    <Link to='/regulamin'>
      <Button variant='contained' style={buttonStyles}>
        Regulamin
      </Button>
    </Link>
  )
}

export const Klodka = () => {
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '10px',

    textAlign: 'center'
  }

  const svgStyle = {
    width: '47px',
    height: '57.69px'
  }

  const svgContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '10vh'
  }

  const textStyle = {
    color: '#000',
    fontFamily: 'Poppins',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: '600',
    fontHeight: 'normal'
  }

  const Tekst = {
    color: '#000',
    fontFamily: 'Poppins',
    fontSize: '13px',
    marginTop: '30px',
    fontStyle: 'normal',
    fontWeight: '600',
    fontHeight: 'normal'
  }

  return (
    <div style={containerStyle}>
      <div style={svgContainerStyle}>
        <svg style={svgStyle} xmlns='http://www.w3.org/2000/svg' width='47' height='58' viewBox='0 0 47 58' fill='none'>
          <path
            d='M6.84822 25.7171V25.3238C6.84822 22.488 6.83808 19.6515 6.85047 16.8157C6.87132 12.041 8.5876 7.96662 12.0196 4.65239C14.7332 2.03233 17.9945 0.504803 21.7516 0.0979892C30.3296 -0.830019 38.1994 4.92735 39.9371 13.3854C40.176 14.5478 40.2695 15.7254 40.2689 16.9115C40.2672 19.7191 40.2689 22.5268 40.2689 25.3351C40.2689 25.4467 40.2689 25.5577 40.2689 25.6996C40.4002 25.7064 40.5084 25.7137 40.6166 25.7171C41.4697 25.7442 42.334 25.6901 43.173 25.8118C45.3552 26.129 46.9994 28.1011 47 30.3042C47 37.8071 47.0005 45.3107 46.9977 52.8136C46.9966 55.1948 45.4059 57.1359 43.0727 57.6018C42.7622 57.6638 42.4388 57.6864 42.1216 57.6864C29.707 57.6903 17.2924 57.6914 4.87782 57.6886C2.12704 57.6886 0.00507109 55.5695 0.00338072 52.8159C-0.00112691 45.4065 -0.00112691 37.9976 0.00338072 30.5882C0.00507109 28.1157 1.71008 26.1115 4.14871 25.7729C4.90543 25.6675 5.68581 25.7306 6.45549 25.7177C6.57551 25.7154 6.69552 25.7177 6.84822 25.7177V25.7171ZM23.5591 55.281C26.9771 55.281 30.395 55.281 33.8129 55.281C36.5924 55.281 39.3719 55.277 42.1509 55.2844C42.7335 55.2861 43.2693 55.1638 43.7364 54.8094C44.2864 54.3924 44.6261 53.8425 44.6847 53.1506C44.7033 52.9331 44.5934 52.7071 44.5934 52.4846C44.5884 45.2166 44.5901 37.9491 44.5889 30.6811C44.5889 29.1457 43.5787 28.1169 42.0658 28.1163C29.6901 28.1146 17.3138 28.1146 4.93811 28.1186C4.69639 28.1186 4.44847 28.1433 4.21464 28.2025C3.10125 28.4837 2.40708 29.4168 2.40651 30.6445C2.40313 38.0156 2.40426 45.3867 2.40651 52.7578C2.40651 52.9635 2.41834 53.1725 2.45835 53.3737C2.66119 54.3924 3.61061 55.2934 4.96685 55.2889C11.1643 55.2691 17.3617 55.2804 23.5586 55.2804L23.5591 55.281ZM15.2826 25.6957H31.8487C31.8487 25.5909 31.8487 25.5075 31.8487 25.4236C31.8487 22.5409 31.8537 19.6583 31.843 16.7762C31.8414 16.2905 31.8036 15.7998 31.7275 15.3197C30.9866 10.6391 26.2525 7.50234 21.6473 8.63037C17.9071 9.54655 15.3074 12.7909 15.2752 16.6359C15.2504 19.5839 15.2696 22.5325 15.2696 25.4805C15.2696 25.5453 15.2775 25.6101 15.2826 25.6951V25.6957ZM37.8534 25.6985C37.8579 25.5982 37.8652 25.516 37.8652 25.4331C37.8652 22.5133 37.8754 19.5929 37.8624 16.6731C37.8495 13.8525 37.0663 11.2589 35.5286 8.88844C32.2769 3.87482 26.1009 1.38943 20.299 2.77101C13.8193 4.31432 9.25586 10.0858 9.25135 16.7458C9.24966 19.6189 9.25135 22.4919 9.25135 25.365C9.25135 25.4731 9.25135 25.5819 9.25135 25.7013H12.8575C12.8575 25.5757 12.8575 25.4658 12.8575 25.3554C12.8575 22.5387 12.8496 19.722 12.8631 16.9053C12.8659 16.2877 12.8952 15.6628 12.9932 15.0549C13.4187 12.423 14.6256 10.1962 16.7002 8.52219C20.0854 5.79113 23.8859 5.16851 27.8549 6.94621C32.0605 8.82984 34.1718 12.2517 34.2512 16.8647C34.2997 19.6994 34.2603 22.5353 34.2603 25.3712V25.6985H37.854H37.8534Z'
            fill='#00A3FF'
          />
          <path
            d='M23.7124 49.9952C22.6328 49.9952 21.5532 49.9975 20.4736 49.9947C19.5028 49.9919 18.9737 49.3439 19.1394 48.3866C19.4448 46.6224 19.7383 44.8554 20.0477 43.0918C20.0787 42.9149 19.9936 42.8399 19.8882 42.7419C18.5765 41.522 17.8739 40.0345 17.9184 38.223C17.9815 35.6458 19.975 33.3412 22.5178 32.9023C25.6405 32.3636 28.5068 34.2957 29.0973 37.4054C29.4804 39.4232 28.8899 41.1715 27.3833 42.5864C27.2311 42.7289 27.1692 42.8428 27.2114 43.0602C27.5732 44.9191 27.9163 46.7807 28.2707 48.6413C28.3851 49.2408 27.878 49.9214 27.2311 49.9727C26.7736 50.0093 26.3121 49.993 25.8524 49.9947C25.139 49.9975 24.4257 49.9952 23.7124 49.9952ZM25.4574 47.3414C25.4608 47.2873 25.4675 47.2591 25.463 47.2326C25.1926 45.6521 24.9227 44.0711 24.6483 42.4906C24.5491 41.9187 24.7035 41.5677 25.1937 41.2487C26.2479 40.563 26.777 39.6192 26.6812 38.3329C26.5567 36.6645 25.4613 35.4666 23.7969 35.2322C21.8209 34.9538 19.971 36.7631 20.2083 38.7386C20.3424 39.8576 20.9295 40.6661 21.8868 41.2296C22.3866 41.5237 22.568 41.8838 22.4784 42.4224C22.3071 43.449 22.1268 44.4745 21.951 45.5006C21.8473 46.108 21.7454 46.7159 21.64 47.3408H25.458L25.4574 47.3414Z'
            fill='#00A3FF'
          />
        </svg>
      </div>
      <div style={textStyle}>
        Zaloguj się
        <div style={Tekst}>
          Wpisz swój numer telefonu, aby uzyskać dostęp do programu lojalnościowego oraz historii zamówień
        </div>
      </div>

      <InputPhoneNumber />

      <RegulaminComponent />
    </div>
  )
}
